import { Component, OnChanges, Input, Output, EventEmitter, OnInit, OnDestroy, SimpleChanges, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GlobalCfgFactory } from '@shared/factories/global-cfg/global-cfg.factory';
import { ConceptFormParentService } from '../utils/concept-form-parent.service';
import { AfTranslatePipe } from '@shared/modules/translate/pipe/af-translate.pipe';
import { AfTranslateDirective } from '../../../modules/translate/directive/af-translate.directive';
import { FieldItemComponent } from '../../field-item/field-item.component';
import { FormsModule } from '@angular/forms';
import { TooltipModule } from 'primeng/tooltip';
import { TooltipLawComponent } from '../../tooltip-law/tooltip-law.component';
import { BoxProtectionComponent } from '../../../../core/components/box-protection/box-protection.component';
import { BoxQueryStateComponent } from '../../../../core/components/box-query-state/box-query-state.component';
import { ProcessRecordComponent } from '../../../../core/components/process-record/process-record.component';
import { NgClass } from '@angular/common';
import { ConceptStepsComponent } from '@shared/components/concept-steps/concept-steps.component';
import { FieldTypeRichTextComponent } from '@shared/components/field-type-rich-text/field-type-rich-text/field-type-rich-text.component';
import { AttachmentsTemplateComponent } from "../../attachments-template/attachments-template.component";
import { ApplicantNotificationsComponent } from '@shared/components/applicant-notifications/applicant-notifications.component';
import { BoxCommunicationChannelComponent } from '@shared/components/box-communication-channel/box-communication-channel.component';
import { BoxCommentsComponent } from '@shared/components/box-comments/box-comments.component';
import { SubcontainerMultipleComponent } from "../../subcontainer-multiple/subcontainer-multiple.component";
import { ConceptLegalDocumentationComponent } from '@shared/components/concept-legal-documentation/concept-legal-documentation.component';
import { StatesProcessComponent } from "../../states-process/states-process.component";
import { ModalServiceService } from '@shared/services/modal-service/modal-service.service';

@Component({
    selector: 'concept-form-custom',
    templateUrl: './concept-form-custom.component.html',
    imports: [
        NgClass,
        ProcessRecordComponent,
        BoxQueryStateComponent,
        BoxProtectionComponent,
        ConceptStepsComponent,
        TooltipLawComponent,
        TooltipModule,
        FormsModule,
        FieldItemComponent,
        AfTranslateDirective,
        AfTranslatePipe,
        FieldTypeRichTextComponent,
        AttachmentsTemplateComponent,
        ApplicantNotificationsComponent,
        BoxCommunicationChannelComponent,
        BoxCommentsComponent,
        SubcontainerMultipleComponent,
        ConceptLegalDocumentationComponent,
        StatesProcessComponent
    ]
})
export class ConceptFormCustomComponent implements OnChanges, OnInit, OnDestroy {
  skin: string = this.globalCfg.skin;
  isLanding: boolean = true;
  params: any = this.route.snapshot.params
  currentComponent: string = this.route.snapshot.data['componentName'];
  locationName: any = this.route.snapshot.data['name'];
  fieldContainerId: any = this.route.snapshot.params['fieldContainerId'];
  conceptObjectId: any = this.route.snapshot.params['conceptObjectId'];
  isMonitoring: any = this.route.snapshot.data['isMonitoring'];
  public: any = this.route.snapshot.data['public'];
  conceptForm: any = this.conceptFormParent.configureConceptFormObject(this);
  subcontainerMultipleChange: boolean = false;
  descriptionField: any = {
    isHighlight: true
  }

  constructor(
    private globalCfg: GlobalCfgFactory,
    private route: ActivatedRoute,
    private conceptFormParent: ConceptFormParentService,
    private modalService: ModalServiceService
  ) {
  }

  @Input() concept: any = null;
  @Input() conceptList: any = null;
  @Input() published:any = null;
  @Input() lockedDataEvaluation: any = null;
  @Input() evaluationId: any = null;
  @Input() footerConceptPublic: any = null;
  @Input() parentConcept: any = null;
  @Input() hasLinksToForms: any = null;
  @Input() disabledSave: any = null;
  @Input() formalitiesList: any = null;
  @Input() lockComToManager: boolean = false;
  @Output() launchAction = new EventEmitter();
  @ViewChild(SubcontainerMultipleComponent) subcontainerMultiple: SubcontainerMultipleComponent;

  ngOnDestroy(){
    this.conceptFormParent.ngOnDestroy();
  }

  ngOnInit(){
    this.conceptFormParent.onInit(this);
    this.setDescriptionField();
    if (this.public && this.conceptForm.custom?.dataTreatmentModal && location.pathname.indexOf('monitoring') === -1) {
      this.modalService.modalAcceptation({})
        .subscribe((result:any)=>{

        })
    }
  }

  private setDescriptionField() {
    this.descriptionField.description = this.concept?.description;
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.conceptFormParent.onChanges(this, changes);
  }

  changesInEvaluatedConcept(e:any){
    this.conceptFormParent.changesInEvaluatedConcept(e.field, this);
  }

  changesInEvaluatedConceptAdditional(e:any) {
    this.conceptFormParent.changesInEvaluatedConceptAdditional(e.field, this);
  }

  changesInMultipleConcept(e:any){
    this.conceptFormParent.changesInMultipleConcept(e.field, this);
  }

  clear(){
    this.conceptFormParent.clear(this);
  }

  saveCreateConcept(event:any){
    this.conceptFormParent.saveCreateConcept('saveBeforeSubcontainer', this);
  }

  saveConcept(type:any ='') {
    this.conceptFormParent.saveConcept(type, this);
  }

  generateDocument(e:any){
    this.conceptFormParent.generateDocument(e.template, this);
  }

  launchActionGeneralConcept(action:any){
    this.conceptFormParent.launchActionGeneralConcept(action, this);
  }

  sendChangeStep(step:any){
    this.conceptFormParent.sendChangeStep(step, this);
  }

  goBack(){
    if(this.conceptForm.concept?.publicLite){
      this.conceptFormParent.closeConceptUserProfile(this);
    }else if(this.skin === 'icam-red'){
      this.launchAction.emit({
        type:'showProcedures',
        item: this.conceptForm.concept
      });
    }else{
      this.conceptFormParent.goBack(this);
    }
  }

  openRelatedInfo(relatedInfo:any){
    this.conceptFormParent.openRelatedInfo(relatedInfo, this);
  }

  changeResponsible(responsible:any) {
    this.conceptFormParent.changeResponsible(responsible, this);
  }

  changeLockedEdit(lockedEdit:any){
    this.conceptFormParent.changeLockedEdit(lockedEdit, this);
  }

  changeConceptFromField(template:any){
    this.conceptFormParent.changeConceptFromField(template, this);
  }

  onSubcontainerMultipleChange() {
    this.conceptFormParent.onSubcontainerMultipleChange(this);
  }
}
